import React, { Suspense, useEffect } from 'react';
import './i18n'; // Importe a instância i18n

// Importação da biblioteca de animação e seu CSS
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// Importação dos componentes principais
import ContactForm from './components/ContactForm';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Footer from './components/Footer';
import ThreatLandscape from './components/ThreatLandscape';
import WhyCrucial from './components/WhyCrucial';
import HowItWorks from './components/HowItWorks';
import WhoBenefits from './components/WhoBenefits';
import PromptDemo from './components/PromptDemo';
import ReactGA from 'react-ga4';

function App() {
  // Inicializa a biblioteca de animação quando o app é carregado
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Página Inicial" });
    AOS.init({
      duration: 1000, // Duração da animação em milissegundos
      once: true,     // Animação acontece apenas uma vez
      offset: 100,      // Animação começa 100px antes do elemento aparecer na tela
    });

    // --- CÓDIGO DE CORREÇÃO PARA A ROLAGEM ---

    const handleInitialAnchorScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    // Usamos um timeout maior para dar tempo para as animações Lottie e
    // outros elementos pesados carregarem e estabilizarem o layout.
    const scrollTimeout = setTimeout(handleInitialAnchorScroll, 500); // Aumentado para 500ms

    // Limpa o timeout se o componente for desmontado
    return () => {
      clearTimeout(scrollTimeout);
    };

  }, []);

  return (
    // Suspense é para o carregamento das traduções
    <HelmetProvider>
      <Suspense fallback="Carregando...">
        <div className="App">
          <Navbar />
          <main>
            <Hero />
            <ThreatLandscape />
            <WhyCrucial />
            <PromptDemo />
            <Solutions />
            <HowItWorks />
            <WhoBenefits />
            <ContactForm />
          </main>
          <Footer />
        </div>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;